import { FormattedNumber as IntlFormattedNumber } from 'react-intl';

interface FormattedNumberProps {
  value: number | undefined | null;
}

export const FormattedNumber = ({ value }: FormattedNumberProps) => {
  if (value === null || value === undefined) {
    return '-';
  }

  return <IntlFormattedNumber value={value} minimumFractionDigits={2} maximumFractionDigits={2} />;
};
